export default "__VITE_ASSET__RhRRndLioJ_FP1YU0IzXDg__"